export const TRY_AND_BUY_PERIOD_UNIT_SECONDS = 's';
export const TRY_AND_BUY_PERIOD_UNIT_MINUTES = 'min';
export const TRY_AND_BUY_PERIOD_UNIT_DAYS = 'day(s)';
export const TRY_AND_BUY_PERIOD_UNIT_WEEKS = 'week(s)';
export const TRY_AND_BUY_PERIOD_UNIT_MONTHS = 'month(s)';
export const TRY_AND_BUY_PERIOD_UNIT_YEARS = 'year(s)';
export const TRY_AND_BUY_PERIOD_UNIT_BILLING_PERIOD = 'billing period';
export const TRY_AND_BUY_PERIOD_UNIT_BINDING_PERIOD = 'binding period';

export const TRY_AND_BUY_STATUS_INIT = 'init';
export const TRY_AND_BUY_STATUS_USING = 'using';
export const TRY_AND_BUY_STATUS_USED = 'used';

export const TRY_AND_BUY_STATUS_ATTRIBUTE_ID = 'TaBStatus';
export const TRY_AND_BUY_END_DATE_ATTRIBUTE_ID = 'TaBEndDate';

/**
 * @property {'init'|'using'|'used'} status
 * @property {number} period
 * @property {'day(s)'} periodUnit
 * @property {string} endDate
 */
export class TryAndBuy {
  constructor({ status, period, periodUnit, endDate }) {
    this.status = status;
    this.period = period;
    this.periodUnit = periodUnit;
    this.endDate = endDate;
  }

  /**
   *
   * @returns boolean
   */
  canBeActivated() {
    return this.status === TRY_AND_BUY_STATUS_INIT;
  }

  /**
   *
   * @returns boolean
   */
  isActive() {
    return this.status === TRY_AND_BUY_STATUS_USING;
  }

  /**
   *
   * @returns boolean
   */
  isUsed() {
    return this.status === TRY_AND_BUY_STATUS_USED;
  }
}
